export { default as DiscloseText } from './DiscloseText'
